import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { apiFetch } from '../lib/apiFetch'

const baseQuery = fetchBaseQuery({
  baseUrl: '/',
  fetchFn: (input, init) => apiFetch(input, init),
})

// The store registers these shells eagerly; admin routes inject their endpoints when loaded.
export const adminEvalsApi = createApi({
  reducerPath: 'adminEvalsApi',
  baseQuery,
  tagTypes: ['AdminEval'],
  endpoints: () => ({}),
})

export const adminErrorBucketsApi = createApi({
  reducerPath: 'adminErrorBucketsApi',
  baseQuery,
  endpoints: () => ({}),
})

export const adminCriticsApi = createApi({
  reducerPath: 'adminCriticsApi',
  baseQuery,
  tagTypes: ['Critic', 'CriticList', 'CriticRun'],
  endpoints: () => ({}),
})

export const adminBugAcceptanceApi = createApi({
  reducerPath: 'adminBugAcceptanceApi',
  baseQuery,
  endpoints: () => ({}),
})

export const adminAnalysisApi = createApi({
  reducerPath: 'adminAnalysisApi',
  baseQuery,
  tagTypes: ['AdminAnalysis'],
  endpoints: () => ({}),
})

export const adminAggregatesApi = createApi({
  reducerPath: 'adminAggregatesApi',
  baseQuery,
  endpoints: () => ({}),
})

export const adminProductUsageApi = createApi({
  reducerPath: 'adminProductUsageApi',
  baseQuery,
  endpoints: () => ({}),
})
